<script setup lang="ts">
import axios from 'axios'

const router = useRouter()
const route = useRoute()

const redirect = async () => {
  // When copying autopilot from template, we simply redirect user to its detail after creation
  const templateId = route.params?.templateId
  if (templateId) {
    const { data } = await axios.put(`/autopilot-templates/${templateId}/copy`)
    const autopilotId = data.data.id
    router.replace({ name: 'AutopilotDetail', params: { autopilotId: autopilotId } })
  }
}
redirect()
</script>
